import React from 'react'
import * as classes from './Presentations.module.scss'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import Item from '../../CorporateGovernance/Item'

function onFormatBytes(bytes) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i) / 1000).toFixed(2))}`
}

function Presentations({ files, lang }) {
    if (!files || !files.length) {
        return null
    }

    const title = lang === 'hy' ? 'Պրեզենտացիաներ' : 'Presentations'

    return (
        <section className={classes.Section}>
            <Container>
                <SectionTitle className={classes.SectionTitle} title={title} lang={lang} />

                <Item files={files} onFormatBytes={onFormatBytes} lang={lang} />
            </Container>
        </section>
    )
}

export default Presentations
